import TagSelect from './TagSelect';
import withStyles from 'react-jss';
import styles from './styles';
import { injectIntl } from 'react-intl';
export default withStyles(styles)(injectIntl(TagSelect));



//////////////////
// WEBPACK FOOTER
// ./src/components/TagSelect/index.tsx
// module id = 1485
// module chunks = 0